import { render, staticRenderFns } from "./productBack.vue?vue&type=template&id=54a122db&"
import script from "./productBack.vue?vue&type=script&lang=js&"
export * from "./productBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports